'use strict';

const base = require('friartux/product/base');
const detail = require('base/product/detail');
const urlHelper = require('friartux/utils/urlHelper');
const inputDateHelper = require('friartux/components/inputDateHelper');

const exportDetails = $.extend({}, detail, base, {});

const { CLASSES } = require('friartux/utils/globals');
const SELECTORS = {
    body: 'body',
    eventDateModal: '#eventDateModal',
    eventDateForm: '.js-event-date-form',
    dateInput: '.js-input-date',
    addToCartCTA: '.js-add-to-cart-modal',
    addToCartButton: 'button.add-to-cart',
    buyAddToCartButton: '.buyContainer.disabled button.add-to-cart, .buyContainer.disabled button.js-add-to-cart-modal',
    rentAddToCartButton: '.rentContainer.disabled button.add-to-cart, .rentContainer.disabled button.js-add-to-cart-modal'
}

/**
 * Init page events
 * @returns {void}
 */
function init() {
    $(document).on('submit', SELECTORS.eventDateForm, handleEventDateFormSubmit);

    $('body').on('product:updateAddToCart', function (e, response) {
        $(SELECTORS.addToCartCTA)[(!response.product.available) ? 'addClass' : 'removeClass'](CLASSES.disabled).attr('disabled', !response.product.available);
        $(SELECTORS.addToCartButton, response.$productContainer).attr('disabled', !response.product.available);
    });

    handleWomensBlocking();
}

/**
 * Handle 'EventDate' Form Submit.
 * Send Ajax to Search-SetEventDate Controller
 * and add product to the Cart after
 * @returns {void}
 */
const handleEventDateFormSubmit = (e) => {
    e.preventDefault();
    $.spinner().start();

    const $form = $(e.target);
    const selectedDate = inputDateHelper.getDate($form.find(SELECTORS.dateInput).first());

    let url = urlHelper.appendToUrl($form.attr('action'), {
        date: selectedDate
    });

    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success:  function (data) {
            $.spinner().stop();

            if (data.success) {
                $(SELECTORS.eventDateModal).modal('hide')
                base.methods.handleAddToCart.call(SELECTORS.addToCartCTA);
            }
        }
    });
}

function handleWomensBlocking() {
    // Disable add to cart.
    $(SELECTORS.buyAddToCartButton)
        .attr('disabled', true)
        .addClass('disabled');
    $(SELECTORS.rentAddToCartButton)
        .attr('disabled', true)
        .addClass('disabled');
}

exportDetails.init = init;

module.exports = exportDetails;
